import Swiper from 'swiper/dist/js/swiper.js';

// Slider on homepage
const homeSliderContainer = document.querySelectorAll('.js-home-slider');

if (homeSliderContainer.length) {

  homeSliderContainer.forEach((sliderEl) => {
    const homeSliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const homeSliderNav = sliderEl.querySelectorAll('[class*="swiper-button-"]');

    if(homeSliderEl.length > 1) {

      if (sliderEl.querySelectorAll('.js-background-video').length) {
        const homeSlider = new Swiper(sliderEl, {
          slidesPerView: 1,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          },
          on: {
            init: function () {
              const currentSlideVideo = this.slides[this.activeIndex].querySelector('.js-background-video');
              if (currentSlideVideo && typeof YT != 'undefined') {
                YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
              }
            },
            slideChangeTransitionEnd: function () {
              // play video on slider changes
              const currentSlideVideo = this.slides[this.activeIndex].querySelector('.js-background-video');
              if (currentSlideVideo && typeof YT != 'undefined') {
                YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
              }

              const previousSlideVideo = this.slides[this.previousIndex].querySelector('.js-background-video');
              if (previousSlideVideo && typeof YT != 'undefined') {
                YT.get(previousSlideVideo.querySelector('iframe').id).pauseVideo();
              }
            }
          }
        });
      } else {
        const homeSlider = new Swiper(sliderEl, {
          slidesPerView: 1,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          }
        });
      }
    } else {
      if (sliderEl.querySelectorAll('.js-background-video').length){
        const currentSlideVideo = sliderEl.querySelector('.js-background-video');
        if (currentSlideVideo && typeof YT != 'undefined') {
          YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
        }
      }

      homeSliderNav.forEach((item) => {
        item.classList.add('visually-hidden');
      });
    }
  });
}

// Slider on header
const headerSliderContainer = document.querySelectorAll('.js-universe-slider');

if (headerSliderContainer.length) {

  headerSliderContainer.forEach((sliderEl) => {
    const headerSliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const headerSliderNav = sliderEl.querySelectorAll('[class*="swiper-button-"]');

    if(headerSliderEl.length > 1) {

      if (sliderEl.querySelectorAll('.js-background-video').length) {
        const headerSlider = new Swiper(sliderEl, {
          slidesPerView: 1,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          },
          on: {
            init: function () {
              const currentSlideVideo = this.slides[this.activeIndex].querySelector('.js-background-video');
              if (currentSlideVideo && typeof YT != 'undefined') {
                YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
              }
            },
            slideChangeTransitionEnd: function () {
              // play video on slider changes
              const currentSlideVideo = this.slides[this.activeIndex].querySelector('.js-background-video');
              if (currentSlideVideo && typeof YT != 'undefined') {
                YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
              }

              const previousSlideVideo = this.slides[this.previousIndex].querySelector('.js-background-video');
              if (previousSlideVideo && typeof YT != 'undefined') {
                YT.get(previousSlideVideo.querySelector('iframe').id).pauseVideo();
              }
            }
          }
        });
      } else {
        const headerSlider = new Swiper(sliderEl, {
          slidesPerView: 1,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          }
        });
      }

      headerSliderNav.forEach((item) => {
        item.classList.remove('visually-hidden');
      });
    } else {
      if (sliderEl.querySelectorAll('.js-background-video').length){
        const currentSlideVideo = sliderEl.querySelector('.js-background-video');
        if (currentSlideVideo && typeof YT != 'undefined') {
          YT.get(currentSlideVideo.querySelector('iframe').id).playVideo();
        }
      }
    }
  });
}

// Testimonials from riders (displayed on multiple pages)
const ridersSliderContainer = document.querySelectorAll('.js-riders-slider');


if(ridersSliderContainer.length) {
  ridersSliderContainer.forEach((sliderEl) => {
    const ridersSliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const ridersSliderNav = sliderEl.querySelectorAll('[class*="swiper-button-"]');

    if(ridersSliderEl.length > 1) {
      const ridersSlider = new Swiper(sliderEl, {
        slidesPerView: 1,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: sliderEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev')
        }
      });
    } else {
      ridersSliderNav.forEach((item) => {
        item.classList.add('visually-hidden');
      });
    }
  });
}

// Sliders with products (displayed on multiple pages)
const productSliderContainer = document.querySelectorAll('.js-products-slider');

if (productSliderContainer.length) {
  productSliderContainer.forEach((sliderEl) => {
    const productSliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const productSliderNav = sliderEl.querySelector('.products-slider__nav');

    if(productSliderEl.length > 4) {
      const productImages = new Swiper(sliderEl, {
        slidesPerView: 4,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: sliderEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          // when window width is <= 640px
          640: {
            slidesPerView: 1
          },
          1024: {
            slidesPerView: 2
          }
        }
      });
    } else {
      productSliderNav.classList.add('visually-hidden');
      sliderEl.classList.add('no-swiper');
    }
  })
}

// Gallery slider
const gallerySliderContainer = document.querySelectorAll('.js-gallery-slider');

if (gallerySliderContainer.length) {
  gallerySliderContainer.forEach((sliderEl) => {
    const gallerySliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const gallerySliderNav = sliderEl.querySelectorAll('[class*="swiper-button-"]');

    if(gallerySliderEl.length > 1) {
      if (sliderEl.querySelector('.video-iframe')) {
        const gallerySliderContainer = new Swiper(sliderEl, {
          slidesPerView: 1,
          shortSwipes: false,
          longSwipesRatio: 0.2,
          longSwipesMs: 100,
          loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: false,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return `<span class="${currentClass}"></span>
                        of
                      <span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          },
          on: {
            slideChangeTransitionStart: function () {
              // pause video on slider changes
              var isVideo = this.slides[this.previousIndex].querySelector('.video-container');
              if (isVideo && typeof YT != 'undefined') {
                YT.get(isVideo.querySelector('iframe').id).pauseVideo();
              }
            }
          }
        });
      } else {
        const gallerySliderContainer = new Swiper(sliderEl, {
          slidesPerView: 1,
          shortSwipes: false,
          longSwipesRatio: 0.2,
          longSwipesMs: 100,
          loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: false,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return `<span class="${currentClass}"></span>
                        of
                      <span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev')
          }
        });
      }
    } else {
      gallerySliderNav.forEach((item) => {
        item.parentNode.classList.add('visually-hidden');
      });
    }
  });
}


// Page standard videos slider
const standardVideosSliderContainer = document.querySelectorAll('.js-standard-videos-slider');

if (standardVideosSliderContainer.length) {
  standardVideosSliderContainer.forEach((sliderEl) => {
    const standardVideosSliderEl = sliderEl.querySelectorAll('.swiper-slide');
    const standardVideosSliderNav = sliderEl.querySelectorAll('[class*="swiper-button-"]');

    if(standardVideosSliderEl.length > 1) {

      const standardVideosSliderContainer = new Swiper(sliderEl, {
        slidesPerView: 2,
        shortSwipes: false,
        longSwipesRatio: 0.2,
        longSwipesMs: 100,
        spaceBetween: 20,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: sliderEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          // when window width is <= 640px
          640: {
            slidesPerView: 1
          }
        }
      });

    }
  });
}
